<template>
	<section class="m-swipe">
		<h2 class="title">活動內容</h2>
		<van-swipe :autoplay="3000" class="my-swipe" @change="change">
			<van-swipe-item v-for="(item, index) in data">
				<van-image class="swipe-img-item" :src="item.cover_cc || item.cover" />
			</van-swipe-item>
		</van-swipe>
	</section>
</template>

<script setup>
const props = defineProps({
	data: {
		type: Array,
		default: () => [],
	},
});

const emits = defineEmits(["change"]);
const change = index => {
	emits("change", props.data[index]);
};
</script>

<style lang="scss" scoped>
.m-swipe {
	margin: 64px 32px 0;
	font-family: PingFang SC;
}
.title {
	font-weight: 600;
	font-size: 40px;
	color: #333333;
	line-height: 60px;
}

.my-swipe {
	margin-top: 32px;
	padding-bottom: 10px;

	.swipe-img-item {
		width: 100%;
		border-radius: 16px;
		overflow: hidden;
	}
	:deep(.van-swipe__indicators) {
		position: absolute;
		bottom: 0;

		.van-swipe__indicator {
			width: 8px;
			height: 8px;
			background: #c98545;
			border-radius: 198px 198px 198px 198px;
			opacity: 0.6;
		}

		.van-swipe__indicator--active {
			width: 28px;
			height: 8px;
			background: #c98545;
			border-radius: 198px 198px 198px 198px;
			opacity: 1;
		}
	}
}
</style>
